
export class PhoneVerificationDialogContext {
  phone: string;
  sendSmsOnOpen:boolean;
  isUserAbleToEditPhoneNumber: boolean;
}
